import React from 'react'
import Can from 'components/Can'
import { Row, Col } from 'react-bootstrap'
import CardItem from './CardItem'
import { useCompany, useUser } from 'models'

import * as marketingColor from 'images/marketing-color.png'
import * as rebateColor from 'images/rebate-color.png'
import * as statementColor from 'images/statement-color.png'
import * as reportsColor from 'images/reports-color.png'
import * as iconLeadWonColor from 'images/icon-lead-won-color.png'
import * as logoMkt360 from 'images/logo-mkt-360.png'
import * as logoSumo from 'images/sumo-logo.png'
import * as logoComunidade from 'images/comunidade-elite.png'
import * as scanGameLogo from 'images/scan-game.png'
import * as elitePass from 'images/logo/logo_scansource_select_colorido.png'
import * as scancash from 'images/scancash.png'

export default function SectionElite() {
  const user = useUser()
  const {company} = useCompany();
  const { id: fiscalYear } = JSON.parse(localStorage.getItem("Elite:fiscalYear")) || {}

  const items = [
    {
      permission: 'innovation.list',
      path: '/elite/innovation',
      icon: marketingColor,
      title: 'Fundos de Inovação',
      block_by_company: company&&company.isScancash()
    },
    // {
    //   permission: 'scancash.list',
    //   path: '/elite/elite-pass',
    //   icon: rebateColor,
    //   programIcon: elitePass,
    //   title: 'Fundos ScanSource Select',
    //   block_by_fy: fiscalYear == 12 && !!company 
    // },
    // {
    //   permission: 'scancash.statement',
    //   path: '/elite/elite-pass/statement',
    //   icon: statementColor,
    //   title: 'Extrato ScanSource Select',
    //   block_by_fy: fiscalYear == 12 && !!company 
    // },
    {
      permission: 'scancash.list',
      path: '/elite/scancash',
      icon: rebateColor,
      programIcon: scancash,
      title: 'Fundos ScanCash',
    },
    {
      permission: 'innovation.statement',
      path: '/elite/innovation/statement',
      icon: statementColor,
      title: 'Extrato Inovação',
      block_by_company: company&&company.isScancash()
    },
    {
      permission: 'scancash.statement',
      path: '/elite/scancash/statement',
      icon: statementColor,
      title: 'Extrato ScanCash',
    },
    {
      permission: 'marketing.index',
      path: '/elite/actions',
      icon: marketingColor,
      title: 'Fundos de Marketing',
      old:true
    },
    {
      permission: 'rebate.index',
      path: '/elite/rebate',
      icon: rebateColor,
      title: 'Fundos de Rebate',
      old:true
    },
    {
      permission: 'statement.index',
      path: '/elite/statement',
      icon: statementColor,
      title: 'Extrato',
      old:true
    },
    {
      permission: 'marketing360.index',
      path: '//marketing360scansource.emailsp.com/console/login.aspx',
      icon: logoMkt360,
      title: 'Marketing 360',
      target: '_blank'
    },
  ]

  if (user.profile.profile_type_id != 1) {
    items.push({
      permission: 'report.index',
      path: '/elite/reports',
      icon: reportsColor,
      title: 'Relatórios'
    })
  }

  return (<>
    <Col sm="12" md="12" lg="12">
      <h6>Scancash</h6>
    </Col>
    <Row>
      {items.filter(a=>!a.block_by_company && !a.block_by_fy).map((item, idx) => {
        return (
          <Can do={item.permission} on="App" key={idx}>
            <CardItem item={item} className={item.old?"card-old":""}/>
          </Can>
        )
      })}      
    </Row>
  </>)
}